import { ref, watch } from 'vue';

const STORAGE_KEY = 'tchinquiz.mobilePreview';
const enabled = ref(localStorage.getItem(STORAGE_KEY) === '1');

function apply(v: boolean) {
  document.body.classList.toggle('mobile-preview', v);
}
apply(enabled.value);
watch(enabled, v => { apply(v); localStorage.setItem(STORAGE_KEY, v ? '1' : '0'); });

export function useMobilePreview() {
  return {
    enabled,
    toggle: () => { enabled.value = !enabled.value; },
  };
}
